var map = {
	"./bathtub.svg": 50745,
	"./fountain.svg": 10143,
	"./radiator.svg": 2364,
	"./shower.svg": 74815,
	"./tiles.svg": 42830,
	"./toilet.svg": 9006,
	"./utilities.svg": 1249,
	"./washbasin.svg": 27507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71931;